<dx-select-box [dataSource]="dataSource"
               [value]="team"
               (valueChange)="onTeamChange($event)"
               displayExpr="name">
    <div *dxTemplate="let item of 'item'">
        {{item.name}}
    </div>
</dx-select-box>
